import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { InputFormField } from '@playbookux/playbook-web-core';

import {
  InlineLabel,
  InlineInputContainer,
  Button,
  Header,
  Logo,
  InlineFieldContainer,
  SmallContainer,
  NDA,
} from './styles';

import { withTranslation } from '../../../core/i18n';
import { NDA_URL } from './constants';

const FormMobile = ({
  onClick, status, phrases, collectTesterName = true,
}) => (
  <SmallContainer>
    <Logo
      src="/images/playbook-logo.png"
      alt="Playbook"
    />
    {collectTesterName && (
      <>
        <Header>{phrases.enter_information_mobile}</Header>

        <InlineFieldContainer>
          <InlineLabel>
            {phrases.first_name_mobile}
          </InlineLabel>
          <InlineInputContainer>
            <Field
              component={InputFormField}
              name="firstName"
              placeholder={phrases.first_name_mobile_preset_text}
              fluid
            />
          </InlineInputContainer>
        </InlineFieldContainer>

        <InlineFieldContainer>
          <InlineLabel>
            {phrases.last_name_mobile}
          </InlineLabel>
          <InlineInputContainer>
            <Field
              component={InputFormField}
              name="lastName"
              fluid
              placeholder={phrases.last_name_mobile_preset_text}
            />
          </InlineInputContainer>
        </InlineFieldContainer>
      </>
    )}

    <Button
      onClick={onClick}
      type="submit"
      loading={status && status.isLoading}
    >
      {phrases.proceed_to_study_mobile}
    </Button>

    <NDA style={{ marginTop: '40px', fontSize: '14px' }}>
      By clicking &quot;Proceed to study&quot; you agree to the
      {' '}
      <a href={NDA_URL} target="_blank" rel="noopener noreferrer">terms of this NDA</a>
    </NDA>
  </SmallContainer>
);

FormMobile.propTypes = {
  status: PropTypes.shape({
    isLoading: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  phrases: PropTypes.shape({
    enter_information_mobile: PropTypes.string,
    first_name_mobile: PropTypes.string,
    first_name_mobile_preset_text: PropTypes.string,
    last_name_mobile: PropTypes.string,
    last_name_mobile_preset_text: PropTypes.string,
    proceed_to_study_mobile: PropTypes.string,
  }).isRequired,
  collectTesterName: PropTypes.bool.isRequired,
};

export default withTranslation(FormMobile);
